export const USER_DASHBOARD_BASE_PATH = 'dashboard';
export const PROFILE_ROUTES_NAME = {
  PROFILE: {
    path: '',
    name: 'user_profile_sub_menu.user_profile',
    visible: false
  }
};
